module.exports = __webpack_public_path__ + "static/media/driver.3b2fcc6d.svg";